import { render, staticRenderFns } from "./OptionRadioSelector.vue?vue&type=template&id=0b45c6c8&scoped=true&"
import script from "./OptionRadioSelector.vue?vue&type=script&lang=ts&"
export * from "./OptionRadioSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b45c6c8",
  null
  
)

export default component.exports